import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { CheckIcon, XIcon } from 'lucide-react';
export function ParaQuien() {
  const forWho = ['Buscas introspección real, no entretenimiento superficial', 'Te atraen los símbolos, arquetipos y lenguaje mitológico', 'Reconoces patrones en tu vida y quieres entenderlos', 'Valoras experiencias visuales y narrativas inmersivas', 'Quieres explorar tu signo desde una perspectiva profunda'];
  const notForWho = ['Buscas predicciones del futuro o consejos diarios', 'Esperas soluciones mágicas o milagros instantáneos', 'Solo quieres saber si eres compatible con alguien', 'Prefieres astrología tradicional con tránsitos y casas', 'No te interesa el trabajo interno o simbólico'];
  return <section className="py-20 px-6 bg-cosmic-dark" data-id="element-252">
      <div className="container mx-auto max-w-6xl" data-id="element-253">
        <AnimatedSection data-id="element-254">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-16" data-id="element-255">
            ¿Para Quién Es Esto?
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-256">
          <AnimatedSection delay={0.2} data-id="element-257">
            <GlowCard glowColor="#4ADE80" data-id="element-258">
              <h3 className="text-2xl font-serif font-semibold text-white mb-6 flex items-center" data-id="element-259">
                <CheckIcon className="mr-3 text-green-400" size={28} data-id="element-260" />
                Sí es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-261">
                {forWho.map((item, index) => <li key={index} className="flex items-start text-gray-200" data-id="element-262">
                    <CheckIcon className="mr-3 mt-1 text-green-400 flex-shrink-0" size={20} data-id="element-263" />
                    <span data-id="element-264">{item}</span>
                  </li>)}
              </ul>
            </GlowCard>
          </AnimatedSection>

          <AnimatedSection delay={0.4} data-id="element-265">
            <GlowCard glowColor="#EF4444" data-id="element-266">
              <h3 className="text-2xl font-serif font-semibold text-white mb-6 flex items-center" data-id="element-267">
                <XIcon className="mr-3 text-red-400" size={28} data-id="element-268" />
                No es para ti si...
              </h3>
              <ul className="space-y-4" data-id="element-269">
                {notForWho.map((item, index) => <li key={index} className="flex items-start text-gray-200" data-id="element-270">
                    <XIcon className="mr-3 mt-1 text-red-400 flex-shrink-0" size={20} data-id="element-271" />
                    <span data-id="element-272">{item}</span>
                  </li>)}
              </ul>
            </GlowCard>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}